// ListingsGrid.jsx
// Grid component for displaying listings

import React from 'react';
import ListingCard from '../../components/ListingCard';
import { styles } from './styles';

const ListingsGrid = ({ listings }) => {
  return (
    <div style={styles.listingsGrid}>
      {listings.map((listing) => (
        <ListingCard key={listing.id} listing={listing} />
      ))}
    </div>
  );
};

export default ListingsGrid;